//@ts-ignore - importing javascript module
import { processResponse, getResponseActions } from '@alme/ui-web/ref/lib-response-handler';
import { Message } from '@alme/ui-web/types/response';
import { HistoryMessage } from '@alme/ui-web/types/history';
import { AlightCustomSettingsType } from '../../../settings/alight-custom-settings';
import { ResponseAction } from '@alme/types/response/ResponseAction';

export default class ChatBubbleColorResponseHandler {
    _settings: AlightCustomSettingsType;
    _isSpecial: boolean;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
        this._isSpecial = false;
    }

    //this functionality is off in Prod and it is currently being fixed in ALIGHT-8687 bug as this is in WIP
    process(message: Message) : Message {

        let responseActionName = "ChangeChatBubbleColor";
        let processSingle = (response: HistoryMessage) => {
            if (process.env.console_logging_enabled) {
                console.log("inside processSingle", message);
            }
            
            let responseActions: ResponseAction[] = getResponseActions(response);
            let matchingAction = responseActions.filter(r => r.Name === responseActionName)[0];
            //this._isSpecial = !!matchingAction;
            if (!!matchingAction){
                response.type = this._settings.messageConstants.advocacyProactiveResponse;
            }

            return response;
        },
        options = {
            processSingle,
        };
        //return processResponse(message, options);
        const result = processResponse(message, options);
        if (result?.response?.type === this._settings.messageConstants.advocacyProactiveResponse ){
            message.messageType = this._settings.messageConstants.advocacyProactiveResponse;
        }
        return message;
    }

    isSpecial(){
        return this._isSpecial;
    }
}


// WEBPACK FOOTER //
// ./modules/advocacy-chat-bubble/message-handlers/chat-bubble.ts